import React from 'react'
import { makeStyles } from '@material-ui/core'
import { MessagesButton, Typography, Tooltip } from 'components'
import TableCell from '@material-ui/core/TableCell'
import { colors } from 'constants/index'
import { useDispatch } from 'react-redux'
import { goToZendesk } from 'store/actions/common'
import { Link } from 'components'
import { ReactComponent as ShareIcon } from 'static/cases/share.svg'

const useStyles = makeStyles({
  link: {
    color: colors.BLUE_20,
    textDecoration: 'none',
  },
  tooltip: {
    backgroundColor: colors.BASIC.COLOR[80],
    color: colors.WHITE,
    fontSize: 13,
    fontWeight: 'normal',
  },
  tableCellTextClass: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  clientNameCellTextClass: {
    whiteSpace: 'normal',
    overflow: 'hidden',
  },
  btnContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  messageBtn: {
    marginLeft: 8,
  },
  subroleText: {
    fontSize: 11,
    color: colors.BASIC.COLOR[40],
    lineHeight: '12px',
    marginTop: 2,
  },
  shareButton: {
    width: 16,
    height: 16,
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    cursor: 'pointer',
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
})

const TooltipText = ({ goToZendesk }) => (
  <span>
    You can not send messages until your license is approved. Please contact <Link onClick={goToZendesk}>XIRA</Link>{' '}
    admin for details.
  </span>
)

const ProColleaguesTableRow = ({ data, profileIsApproved }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const fullName = `${data.first_name || ''} ${data.last_name || ''}`.trim()
  const username = data.username || ''
  const phoneNumber = data.contact_info?.phone || ''
  const address = data.contact_info?.street || ''
  const city =
    data.contact_info?.city &&
    `${data.contact_info.city}, ${data.contact_info.state ? data.contact_info.state.replace('US-', '') : ''} ${data
      .contact_info.zip || ''}`.trim()

  const zendeskSso = () => {
    dispatch(goToZendesk())
  }

  // Get all shared case names
  const sharedCases = data.shared_case_names || []
  const hasSharedCases = sharedCases.length > 0

  const getShareTooltip = () => {
    if (hasSharedCases) {
      const caseNames = sharedCases.join(', ')
      return `Added as part of ${caseNames} project${sharedCases.length !== 1 ? 's' : ''}`
    }
    return ''
  }

  return (
    <>
      <TableCell>
        <div className={classes.nameContainer}>
          <Typography variant="body2" classes={{ root: classes.clientNameCellTextClass }}>
            {fullName}
          </Typography>
          {hasSharedCases && (
            <Tooltip tooltipClass={classes.tooltip} title={getShareTooltip()} placement="bottom-start">
              <ShareIcon className={classes.shareButton} />
            </Tooltip>
          )}
        </div>
      </TableCell>
      <TableCell>
        <Typography variant="body2" classes={{ root: classes.tableCellTextClass }}>
          {username && (
            <>
              {username}
              {phoneNumber && (
                <>
                  <br />
                  {phoneNumber}
                </>
              )}
            </>
          )}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" classes={{ root: classes.clientNameCellTextClass }}>
          {address && (
            <>
              {address}
              {city && (
                <>
                  <br />
                  {city}
                </>
              )}
            </>
          )}
        </Typography>
      </TableCell>
      <TableCell>
        <div className={classes.btnContainer}>
          <MessagesButton
            className={classes.messageBtn}
            chatId={data?.twilio_chat_sid || ''}
            disabledText={
              !profileIsApproved ? (
                <TooltipText goToZendesk={zendeskSso} />
              ) : (
                'You can not send messages to this colleague'
              )
            }
            disabled={!profileIsApproved || !data.twilio_chat_sid}
            place="connections"
          />
        </div>
      </TableCell>
    </>
  )
}

export default ProColleaguesTableRow
